import { InventoryLocation } from './InventoryLocation'
import type { InventoryTypeEnum } from './InventoryTypeEnum'
import { Product } from '../product/Product'
import { Field, Float, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { RelatedEntity } from '../base/RelatedEntity'
import { UnitOfMeasure } from '../unitOfMeasure/UnitOfMeasure'

@ObjectType()
@modelOptions({ schemaOptions: { timestamps: true } })
export class InventoryTimeSeries extends BaseEntity {
  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * The datetime when this entry is added, having the max value is the latest and the current inventory count
   * With this field available we can query at any point in time the quantity count
   */
  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date
  /**
   * Values can be positive or negative values,
   * Value can have decimal to support for cuts for some part
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * This is the result for the updating the previous runningQuantity, +/- with this.quantity
   */
  @Field(() => Float)
  @Prop({ type: Number })
  runningQuantity: number

  @Field(() => InventoryLocation)
  @Prop({ type: InventoryLocation })
  location?: InventoryLocation

  /**
   * Original transaction quantity (unsigned).
   * For non-converting transaction types, equals Math.abs(quantity).
   * For converting types (e.g., sales, purchases), this is the quantity in the transaction UOM
   * before conversion to base UOM.
   */
  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  transactionQuantity?: number

  /**
   * Snapshot of the UOM used in the original transaction.
   * For sales, this is the order UOM. For purchases, this is the purchase UOM.
   */
  @Field(() => UnitOfMeasure, { nullable: true })
  @Prop({ type: () => UnitOfMeasure })
  transactionUom?: ReturnType<() => UnitOfMeasure>

  /**
   * Snapshot of the product's base UOM at the time of the transaction.
   * Replaces the previous unitOfMeasure string field.
   */
  @Field(() => UnitOfMeasure, { nullable: true })
  @Prop({ type: () => UnitOfMeasure })
  baseUom?: ReturnType<() => UnitOfMeasure>

  /**
   * The reason for change update of quantity, the type of transaction like sales, purchase, adjustment, initialize
   */
  @Field(() => String)
  @Prop({ type: String })
  transactionType: InventoryTypeEnum
  /**
   * The transaction to reference where this change happens
   * When transaction like sales, purchase, adjustment, the value for this should be required
   */
  @Field(() => String)
  @Prop({ type: String })
  transactionRef: string
}
